import { HOTPADS_COMSCORE_ID } from './constants';

export type HotpadsComscoreUserState = {
  userToken?: string | null;
  loggedIn?: boolean | null;
};

export type HotpadsComscoreParams = {
  c1: '2';
  c2: typeof HOTPADS_COMSCORE_ID;
  cs_fpid: string;
  cs_fpit: 'li' | 'lo';
  cs_fpdm: '*null';
  cs_fpdt: '*null';
};

export function getHotpadsComscoreParams(userState: HotpadsComscoreUserState): HotpadsComscoreParams {
  return {
    c1: '2',
    c2: HOTPADS_COMSCORE_ID,
    cs_fpid: userState.userToken ?? '',
    cs_fpit: userState.loggedIn === true ? 'li' : 'lo',
    cs_fpdm: '*null',
    cs_fpdt: '*null',
  };
}
